import api from './api.js'

// Actions Service
export const actionsService = {
  async getAll(params = {}) {
    const response = await api.get('/actions', { params })
    return response.data.success ? response.data.data : []
  },

  async getMyActions(employee_id, params = {}) {
    const queryParams = employee_id ? { employee_id, ...params } : params
    const response = await api.get('/actions/my', { params: queryParams })
    return response.data.success ? response.data.data : []
  },

  async getEmployeesWithActions() {
    const response = await api.get('/actions/employees-with-actions')
    return response.data.success ? response.data.data : []
  },

  async getTypes() {
    const response = await api.get('/actions/types')
    return response.data.success ? response.data.data : []
  },

  async getById(id) {
    const response = await api.get(`/actions/${id}`)
    return response.data.success ? response.data.data : null
  },

  async create(data) {
    const response = await api.post('/actions', data)
    return response.data
  },

  async createWithItems(data) {
    const response = await api.post('/actions/create-with-items', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/actions/${id}`, data)
    return response.data
  },

  async updateStatus(id, status, completionInfo = {}) {
    const response = await api.patch(`/actions/${id}/status`, {
      status,
      ...completionInfo
    })
    return response.data
  },

  async delete(id) {
    const response = await api.delete(`/actions/${id}`)
    return response.data
  },

  async setOutcome(actionId, outcome, userInfo = {}, notes = null) {
    const response = await api.post(`/actions/${actionId}/outcome`, {
      outcome,
      completed_by_name: userInfo.name,
      completed_by_email: userInfo.email,
      notes,
      send_notification: true
    })
    return response.data
  },

  async triggerFollowup(actionId, userInfo = {}) {
    const response = await api.post(`/actions/${actionId}/trigger-followup`, {
      triggered_by_name: userInfo.name,
      triggered_by_email: userInfo.email
    })
    return response.data
  }
}
